__turbopack_context__.v({
  "blockquote": "index-module__9a9RuW__blockquote",
  "code": "index-module__9a9RuW__code",
  "h1": "index-module__9a9RuW__h1",
  "h2": "index-module__9a9RuW__h2",
  "h3": "index-module__9a9RuW__h3",
  "h4": "index-module__9a9RuW__h4",
  "hr": "index-module__9a9RuW__hr",
  "link": "index-module__9a9RuW__link",
  "markdownContainer": "index-module__9a9RuW__markdownContainer",
  "ol": "index-module__9a9RuW__ol",
  "paragraph": "index-module__9a9RuW__paragraph",
  "pre": "index-module__9a9RuW__pre",
  "strong": "index-module__9a9RuW__strong",
  "table": "index-module__9a9RuW__table",
  "tableWrapper": "index-module__9a9RuW__tableWrapper",
  "td": "index-module__9a9RuW__td",
  "th": "index-module__9a9RuW__th",
  "tr": "index-module__9a9RuW__tr",
  "ul": "index-module__9a9RuW__ul",
});
